import { Fragment, useMemo } from "react";
import { css } from "@emotion/react";

const URL_REGEX = /(https?:\/\/\S+|www\.\S+)/g;
export const splitByUrl = (text?: string) => {
  return text ? text.split(URL_REGEX) : [];
};

export interface UserTextRendererProps {
  children?: string;
  renderLink?: (props: { href: string }) => React.JSX.Element;
}

const DefaultRenderLink = ({ href }: { href: string }) => {
  return (
    <a href={href} rel="noopener noreferrer" target="_blank">
      {href}
    </a>
  );
};

export const UserTextRenderer = ({
  children,
  renderLink: RenderLink = DefaultRenderLink,
}: UserTextRendererProps) => {
  const texts = useMemo(() => splitByUrl(children), [children]);
  return (
    <span
      css={css`
        word-break: break-all;
        overflow-wrap: break-word;
        white-space: pre-line;
      `}
    >
      {texts.map((text, index) => {
        return (
          <Fragment key={index}>
            {text.match(URL_REGEX) ? <RenderLink href={text} /> : text}
          </Fragment>
        );
      })}
    </span>
  );
};
